import React from 'react';
import styled from '@emotion/styled';

export const EmojiStyled = styled.span`
  font-family: ${({ theme }) => theme.fonts.emoji};
  font-size: 1.2rem;
  line-height: 1.2rem;
  display: inline-block;
  margin: 0 0.3rem;
`;

export const Emoji = ({ symbol = '', label = '', ...props }) => {
  return (
    <EmojiStyled role="img" aria-label={label} title={label} {...props}>
      {symbol}
    </EmojiStyled>
  );
};
